<template>
  <div
    v-if="!store.mobileApp"
    class="booking-app-download"
    :class="$isPageEditing && 'booking-app-download--editor'"
  >
    <sc-text :field="fields.downloadAppTitle" tag="h2" class="booking-app-download__title font-m" />
    <div class="booking-app-download__content">
      <sc-text :field="fields.downloadAppText" tag="div" />
    </div>
    <div class="booking-app-download__cta-wrapper">
      <img
        v-if="fields.qrCodeImage?.value?.src"
        :src="fields.qrCodeImage?.value?.src"
        :alt="fields.qrCodeImage?.value?.alt"
        class="booking-app-download__qr-image"
      />
      <div class="booking-app-download__links">
        <a
          v-if="fields.appStoreLink?.value?.href"
          :href="fields.appStoreLink?.value?.href"
          target="_blank"
          rel="noopener noreferrer"
          class="booking-app-download__link"
          @click="trackLinkState('Download on the App Store', 'download_the_app')"
        >
          <img
            :src="fields.appStoreImage?.value?.src"
            :alt="fields.appStoreImage?.value?.alt"
            class="booking-app-download__image"
          />
        </a>
        <a
          v-if="fields.googlePlayLink?.value?.href"
          :href="fields.googlePlayLink?.value?.href"
          target="_blank"
          rel="noopener noreferrer"
          class="booking-app-download__link"
          @click="trackLinkState('Get it on Google Play', 'download_the_app')"
        >
          <img
            :src="fields.googlePlayImage?.value?.src"
            :alt="fields.googlePlayImage?.value?.alt"
            class="booking-app-download__image"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Text as ScText } from '@sitecore-jss/sitecore-jss-vue';
import { useBookingAppStore } from '../../stores/bookingAppStore';
import { useButtonsAndLinksTracking } from '../../../../data-layer/hooks/useButtonsAndLinksTracking';

const { trackLinkState } = useButtonsAndLinksTracking({
  componentName: 'App Store Component',
});

defineProps({
  fields: {
    type: Object,
    default: () => ({}),
  },
  rendering: {
    type: Object,
  },
  params: {
    type: Object,
    default: () => ({}),
  },
});

const store = useBookingAppStore();
</script>

<style lang="scss">
@import './scss/BookingAppDownload.scss';
</style>
